<template>
  <div class="pro-inner">
    <div class="pro-inner" style="margin-top: 24px;">
      <el-col :span="4">
        <div class="img-item">
          <img
            src="../../../../static/img/farmersProduce.png"
            alt=""
            style="width: 62px;height:50px"
          />
        </div>
        <div class="font-item1">服务农户数</div>
        <!-- <div class="font-item2">10000</div> -->
        <div class="font-item2">{{GLOBAL.unitConversion(overViewData.nhCount,)}}<span :class="overViewData.nhCount>10000?'exceed':'NotMoreThan'">{{overViewData.nhCount>10000?'万户':'户'}}</span></div>
      </el-col>
      <el-col :span="4">
        <div class="img-item">
          <img
            src="../../../../static/img/服务组织.png"
            style="width: 62px;height:50px"
            alt=""
          />
        </div>
        <div class="font-item1">服务组织数</div>
        <!-- <div class="font-item2">10000</div> -->
        <div class="font-item2">{{GLOBAL.unitConversion(overViewData.enterpriseCount,)}}<span :class="overViewData.enterpriseCount>10000?'exceed':'NotMoreThan'">{{overViewData.enterpriseCount>10000?'万家':'家'}}</span></div>
      </el-col>
      <el-col :span="4">
        <div class="img-item">
          <img
            src="../../../../static/img/农机.png"
            style="width: 62px;height:50px"
            alt=""
          />
        </div>
        <div class="font-item1">农机数</div>
        <!-- <div class="font-item2">10000</div> -->
        <div class="font-item2">{{GLOBAL.unitConversion(overViewData.machineCount,)}}<span :class="overViewData.machineCount>10000?'exceed':'NotMoreThan'">{{overViewData.machineCount>10000?'万台':'台'}}</span></div>
      </el-col>
      <el-col :span="4">
        <div class="img-item">
          <img
            src="../../../../static/img/托管面积.png"
            alt=""
            style="width: 62px;height:50px"
          />
        </div>
        <div class="font-item1">托管面积</div>
        <!-- <div class="font-item2">10000</div> -->
        <div class="font-item2">{{GLOBAL.unitConversion(overViewData.tgmj,)}}<span :class="overViewData.tgmj>10000?'exceed':'NotMoreThan'">{{overViewData.tgmj>10000?'万亩':'亩'}}</span></div>
      </el-col>
      <el-col :span="4">
        <div class="img-item" >
          <img
            src="../../../../static/img/作业面积.png"
            alt=""
            style="width: 62px;height:50px"
          />
        </div>
        <div class="font-item1">作业面积</div>
        <!-- <div class="font-item2">10000</div> -->
        <div class="font-item2">{{GLOBAL.unitConversion(overViewData.serviceArea,)}}<span :class="overViewData.serviceArea>10000?'exceed':'NotMoreThan'">{{overViewData.serviceArea>10000?'万亩.次':'亩.次'}}</span></div>
      </el-col>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie"
import API from "@/api/serviceOrgManagement/api_userManagement";
export default {
  data() {
    return {
      overViewData: {
        nhCount:0,
        enterpriseCount:0,
        machineCount:0,
        tgmj:0,
        serviceArea:0
      },
      qhdm: Cookies.get('areacode'),
    }
  },
   created() {
     this.$nextTick(() => this.queryNzfwgk())
     this.GLOBAL.eventBus.$on("refresh_big_screen_info",this.queryData);
    //  this.GLOBAL.eventBus.$on("refresh_big_screen_info",this.queryData);
   },
   beforeDestroy() {
      this.GLOBAL.eventBus.$off("refresh_big_screen_info",this.queryData);
   },
  methods: {
    queryData(qhdm){
      this.qhdm = qhdm;
      this.queryNzfwgk();
    },

    async queryNzfwgk() {
      let params = {
        qhdm: this.qhdm,
        subsidyPlanName:''
      }

      API.screenDetail(params)
        .then((res) => {
          if (res.code == 0 && res.data) {
            this.overViewData = res.data.stat
          }
        })
        .catch((err) => {});
    },
  }
};
</script>

<style scoped lang="less" scoped>
/*农资供应服务*/
.pro-inner-liangqu {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.pro-inner {
  height: calc(100% - 40px);
  width: 100%;
  display: flex;
  justify-content: space-between;
  // margin-top: 10px;
  .el-col {
    height: 100%;
    color: #fff;
    text-align: center;
    padding-top: 5%;
    padding-bottom: 4%;
    .font-item1 {
      height: 25px;
      font-family: Source Han Sans CN;
      // font-weight: bold;
      font-size: 14px;
      line-height: 25px;
    }
    .font-item2{
      height: 25px;
      font-family: Source Han Sans CN;
      // font-weight: bold;
      font-size: 16px;
      line-height: 25px;
      // width: 100%;
      color: #00D7FE;
      font-weight: bold;
    }
    .exceed{
      display: block;
    }
    .NotMoreThan{
      display: inline-block;
    }
    .img-item {
      position: relative;
      // height: calc(100% -  100px);
      display: flex;
      justify-content: center;
      align-items: center;
      .img-item-c {
        width: 100%;
        position: absolute;
        z-index: 2;
        // line-height: 50px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

}
</style>




// WEBPACK FOOTER //
// src/studio/homepage/home/homerightbottom.vue